import { useState } from 'react';
import { pickBy } from 'lodash';

export type Filters = Record<string, string>;

export type UpdateFilters = (newFilters: Filters) => void;

const useFilters: (initialFilters?: Filters) => [Filters, UpdateFilters] = (initialFilters = {}) => {
  const [filters, setFilters] = useState(initialFilters);

  const updateFilters = (newFilters: Filters) => {
    const newFiltersState = pickBy({ ...filters, ...newFilters }, (v) => v);
    const searchString = new URLSearchParams(newFiltersState).toString();

    window.history.pushState(null, '', `${window.location.pathname}?${searchString}`);
    setFilters(newFiltersState);
  };

  return [filters, updateFilters];
};

export default useFilters;
